export function normalizeConversation(data) {
  if (!data) return null;

  const { conversation, ...message } = data;

  if (!conversation) {
    return null;
  }

  return {
    ...conversation,
    contactInfo: conversation.contactInfo || {},
    message,
  };
}

export function normalizeConversations(datas = []) {
  return datas.map(normalizeConversation).filter(Boolean);
}

export function getConversationContactId(conversation, utils) {
  if (!conversation) return null;

  if (utils && utils.hasProperty(conversation, "contactInfo.identifier")) {
    return conversation.contactInfo.identifier;
  }

  return conversation.sourceId;
}

export function getMessageNotificationContent(message, i18n) {
  if (!message) return "...";

  const metaType = message.meta?.type || "TEXT";

  const translations = {
    IMAGE: "chat.messages.type.image",
    STICKER: "chat.messages.type.sticker",
    VIDEO: "chat.messages.type.video",
    DOCUMENT: "chat.messages.type.file",
    AUDIO: "chat.messages.type.audio",
  };

  if (translations[metaType]) {
    return i18n.t(translations[metaType]);
  }

  return message.content || "...";
}
